import type { BodyRequest } from '@pba/utils';
import type { CredentialResponse } from '@react-oauth/google';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { OauthTokenDataObject } from 'models/service/login';

type SocialLoginRequest = {
  code: CredentialResponse['credential'];
  organization_id?: string;
  organization_slug: string;
  provider: string;
  time_zone: string;
};

export const loginWithSocial = async ({ body }: BodyRequest<SocialLoginRequest>) =>
  apiClient.post<OauthTokenDataObject, ApiClientResponse<OauthTokenDataObject>>(routes.user.oauth, body, {
    skipAuth: true,
  });
